import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const solutionsSlider = new Splide(".our-solutions__slider", {
  pagination: false,
  arrows: false,
  fixedWidth: '21.25rem',
  gap: `0.25rem`,
  wheel: false,
  drag: false,
  autoScroll: {
    speed: 0.5,
    pauseOnFocus: false,
    pauseOnHover: false,
  },
  mediaQuery: 'max',
  breakpoints: {
    960: {
      fixedWidth: '10.625rem',
    }
  }
});

solutionsSlider.mount({ AutoScroll });